import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { ServerPath } from '../../Constant/index.jsx';
import { _axios } from '../../utils/axios';
import Swal from 'sweetalert2';
import UpdatePurple from '../../assets/images/svg/UpdatePurple.svg';
import UpdateBlue from '../../assets/images/svg/UpdateBlue.svg';
import CalendarEdit from '../../assets/images/svg/calendar_edit.svg';
import Img from '../../assets/images/svg/image.svg';
import Video from '../../assets/images/svg/video.svg';
import Cross from '../../assets/images/svg/Cross.svg';

const EditExperience = (props) => {
    const [show, setShow] = useState(false);
    const [experienceId, setExperienceId] = useState(props?.data?.exp_id);
    const [experienceTitle, setExperienceTitle] = useState('');
    const [author, setAuthor] = useState('');
    const [submittedDate, setSubmittedDate] = useState('');
    const [details, setDetails] = useState('');
    const [status, setStatus] = useState('');
    const [reports, setReports] = useState('');
    const [updating, setUpdating] = useState(false);
    const [mediaFiles, setMediaFiles] = useState([]);
    const [selectedMedia, setSelectedMedia] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [showRejectionModal, setShowRejectionModal] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [showReportPopup, setShowReportPopup] = useState(false);
    const [formattedMediaFiles, setFormattedMediaFiles] = useState([]);
    const [reportData, setReportData] = useState({
        totalReports: 0,
        reportReasons: [],
        uniqueReporters: 0
    });

    const fetchReportData = async (expId) => {
        if (expId) {
            try {
                const response = await _axios.get(`${ServerPath}/community-exp/reports/count/${expId}`);
                if (response.data.success === 1) {
                    const { total_reports, report_reasons, unique_reporters } = response.data.data;

                    // Define the complete phrases we want to keep together
                    const completeReasons = [
                        "I just don't like it",
                        "Nudity or sexual activity",
                        "Scam, fraud or spam",
                        "Suicide, self-injury or eating disorders",
                        "Bullying or unwanted contact",
                        "Violence, hate or exploitation",
                        "Selling or promoting restricted items",
                        "False information"
                    ];

                    // Filter and match complete phrases from the report_reasons string
                    const reasonsArray = completeReasons.filter(phrase =>
                        report_reasons?.toLowerCase().includes(phrase.toLowerCase())
                    );

                    setReportData({
                        totalReports: total_reports,
                        reportReasons: reasonsArray,
                        uniqueReporters: unique_reporters
                    });
                }
            } catch (error) {
                console.error('Error in fetchReportData:', error);
                setReportData({
                    totalReports: 0,
                    reportReasons: [],
                    uniqueReporters: 0
                });
            }
        }
    };

    useEffect(() => {
        fetchReportData(props.data?.exp_id);
    }, [props.data?.exp_id]);

    const getFileType = (fileName) => {
        const videoExtensions = ['.mp4', '.mov', '.avi', '.wmv'];
        const ext = fileName.toLowerCase().slice(fileName.lastIndexOf('.'));
        return videoExtensions.includes(ext) ? 'video' : 'image';
    };

    const formatMediaFiles = (files) => {
        let imageCounter = 1;
        let videoCounter = 1;

        return files.map(file => {
            const type = getFileType(file);
            const ext = file.slice(file.lastIndexOf('.'));
            const counter = type === 'video' ? videoCounter++ : imageCounter++;

            return {
                originalPath: file,
                displayName: `${type === 'video' ? 'Video' : 'Image'}${counter}${ext}`,
                type: type
            };
        });
    };

    const dropdownStyles = {
        container: {
            position: 'relative',
        },
        button: {
            width: '100%',
            backgroundColor: '#fff',
            border: '1px solid #dee2e6',
            borderRadius: '0.25rem',
            padding: '0.375rem 0.75rem',
            textAlign: 'left',
            cursor: 'text',
            position: 'relative',
            appearance: 'none',
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            height: '38px',
            fontSize: '1rem',
            lineHeight: '1.5',
            color: '#212529'
        },
        dropdownList: {
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            backgroundColor: '#fff',
            border: '1px solid #dee2e6',
            borderRadius: '0.25rem',
            marginTop: '0.25rem',
            zIndex: 1000,
            maxHeight: '200px',
            overflowY: 'auto',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            padding: '0.25rem'
        },
        item: {
            padding: '0.5rem 0.25rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid #f8f9fa',
            backgroundColor: '#F5F5F5',
            marginBottom: '0.25rem',
            borderRadius: '0.25rem'
        },
        selectedItem: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            paddingRight: '24px'
        },
        fileName: {
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 'calc(100% - 36px)'
        }
    };

    useEffect(() => {
        if (props.data) {
            setExperienceTitle(props.data.experience_title || '');
            setAuthor(props.data.user_name || '');
            setSubmittedDate(formatDate(props.data.created_on));
            setStatus(props.data.status || 'Pending');
            setDetails(props.data.details || '');
            setReports(props.data.reports || '0');

            const mediaUrls = [
                props.data.media1,
                props.data.media2,
                props.data.media3,
                props.data.media4,
                props.data.media5
            ].filter(url => url);

            setMediaFiles(mediaUrls);
            const formatted = formatMediaFiles(mediaUrls);
            setFormattedMediaFiles(formatted);

            if (mediaUrls.length > 0) {
                setSelectedMedia(mediaUrls[0]);
            }
        }
    }, [props.data]);

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US');
    };

    const handleClose = () => setShow(false);
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!status) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Status is required',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        setUpdating(true);
        try {
            const updatedExperience = {
                exp_id: experienceId,
                status: status,
                reason: rejectionReason,
                modified_by: props.data.user_name,
                user_id : props.data.user_id,
                exp_name : experienceTitle
            };

            const response = await _axios.post(`${ServerPath}/experienceAdmin/update-status`, updatedExperience);

            if (response.data.success === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Experience updated successfully',
                    confirmButtonColor: '#3085d6',
                }).then(() => {
                    handleClose();
                    if (props.onUpdate) {
                        props.onUpdate();
                    } else {
                        window.location.reload();
                    }
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'An error occurred while updating the experience',
                confirmButtonColor: '#3085d6',
            });
        } finally {
            setUpdating(false);
        }
    };

    const handleRejection = async () => {
        if (!rejectionReason.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Rejection reason is required',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        try {
            const updatedExperience = {
                exp_id: experienceId,
                status: 'Cancelled',
                reason: rejectionReason,
                modified_by: props.data.user_name,
                user_id : props.data.user_id,
                exp_name : experienceTitle
            };

            const response = await _axios.post(`${ServerPath}/experienceAdmin/update-status`, updatedExperience);

            if (response.data.success === 1) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Experience rejected successfully',
                    confirmButtonColor: '#3085d6',
                }).then(() => {
                    setShowRejectionModal(false);
                    handleClose();
                    if (props.onUpdate) {
                        props.onUpdate();
                    } else {
                        window.location.reload();
                    }
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'An error occurred while rejecting the experience',
                confirmButtonColor: '#3085d6',
            });
        }
    };

    return (
        <>
            <button
                className="btn-icon-only bg-transparent border-0 p-0"
                onClick={handleShow}
                onMouseEnter={(e) => {
                    e.currentTarget.querySelector('img').src = UpdateBlue;
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.querySelector('img').src = UpdatePurple;
                }}
            >
                <img
                    src={UpdatePurple}
                    alt="Update"
                    style={{ width: '24px', height: '24px' }}
                />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="xl"
                centered
            >
                <Modal.Header closeButton className="bg-white border-bottom" style={{ paddingLeft: '24px' }}>
                    <Modal.Title style={{ color: '#000' }}>Update Experience</Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4">
                    <Form id='EditExperienceForm' onSubmit={handleSubmit}>
                        <Row>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridExperienceTitle">
                                    <Form.Label>Experience Title</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={experienceTitle}
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridAuthor">
                                    <Form.Label>Author</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={author}
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridSubmittedDate">
                                    <Form.Label>Submitted Date</Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            value={submittedDate}
                                            readOnly
                                            disabled
                                            className="bg-light"
                                        />
                                        <img
                                            src={CalendarEdit}
                                            alt="calendar"
                                            style={{
                                                position: 'absolute',
                                                right: '12px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '20px',
                                                height: '20px',
                                                pointerEvents: 'none'
                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridReports">
                                    <Form.Label style={{
                                        color: '#FF4D4F',
                                        fontSize: '16px',
                                        fontWeight: '500',
                                        marginBottom: '8px'
                                    }}>
                                        Reports
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={`${reportData.totalReports} Reports`}
                                        readOnly
                                        onClick={() => setShowReportPopup(true)}
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: '#fff',
                                            border: '1px solid #dee2e6',
                                            borderRadius: '8px',
                                            padding: '8px 12px',
                                            fontSize: '16px',
                                            color: '#333',
                                            boxShadow: 'none',
                                            height: 'auto'
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridStatus">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                        required
                                        style={{ color: 'black' }}
                                    >
                                        <option value="Active">Active</option>
                                        <option value="Pending Moderation">Pending Moderation</option>
                                        <option value="Review">Review</option>
                                        <option value="Reported">Reported</option>
                                        <option value="Cancelled">Cancelled</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col md={6} className="mb-4">
                                <Form.Group controlId="formGridContent">
                                    <Form.Label>Content</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={details}
                                        onChange={(e) => setDetails(e.target.value)}
                                        placeholder="Enter content"
                                        readOnly
                                        disabled
                                        className="bg-light"
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3} className="mb-4">
                                <Form.Group controlId="formGridVideoImage">
                                    <Form.Label>Media Files</Form.Label>
                                    <div style={dropdownStyles.container}>
                                        <button
                                            type="button"
                                            style={dropdownStyles.button}
                                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                            className="form-control"
                                        >
                                            {selectedMedia ? (
                                                <div style={dropdownStyles.selectedItem}>
                                                    <img
                                                        src={getFileType(selectedMedia) === 'video' ? Video : Img}
                                                        alt="file icon"
                                                        width="20"
                                                        height="20"
                                                    />
                                                    <span style={dropdownStyles.fileName}>
                                                        {formattedMediaFiles.find(file => file.originalPath === selectedMedia)?.displayName ||
                                                            selectedMedia.split('/').pop()}
                                                    </span>
                                                </div>
                                            ) : (
                                                <span>Select file</span>
                                            )}
                                        </button>

                                        {isDropdownOpen && (
                                            <div style={dropdownStyles.dropdownList}>
                                                {formattedMediaFiles.map((file, index) => (
                                                    <div
                                                        key={index}
                                                        style={dropdownStyles.item}
                                                        onClick={() => {
                                                            setSelectedMedia(file.originalPath);
                                                            setIsDropdownOpen(false);
                                                        }}
                                                        className="hover:bg-gray-100"
                                                    >
                                                        <img
                                                            src={file.type === 'video' ? Video : Img}
                                                            alt="file icon"
                                                            width="20"
                                                            height="20"
                                                            className="me-2"
                                                        />
                                                        <span style={dropdownStyles.fileName}>
                                                            {file.displayName}
                                                        </span>
                                                        <img src={Cross} alt="dropdown" width="16" height="16" />
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>
                            </Col>

                            {selectedMedia && (
                                <Col md={3} className="mb-4">
                                    <div className="border rounded p-2">
                                        {getFileType(selectedMedia) === 'video' ? (
                                            <video
                                                src={selectedMedia}
                                                controls
                                                style={{
                                                    width: '240px',
                                                    height: '200px',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        ) : (
                                            <img
                                                src={selectedMedia}
                                                alt="Experience media"
                                                style={{
                                                    width: '240px',
                                                    height: '200px',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        )}
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top">
                    <Button
                        variant="#F24822"
                        onClick={() => {
                            handleClose();
                            setShowRejectionModal(true);
                        }}
                        style={{
                            backgroundColor: '#F24822',
                            border: 'none',
                            padding: '8px 24px',
                            color: 'white'
                        }}
                    >
                        Reject
                    </Button>
                    <Button
                        form='EditExperienceForm'
                        variant="#EEB830"
                        type='submit'
                        disabled={updating}
                        style={{
                            backgroundColor: '#EEB830',
                            border: 'none',
                            padding: '8px 24px',
                            color: 'white'
                        }}
                    >
                        {updating ? 'Updating...' : 'Approve'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Report Popup Modal */}
            <Modal
                show={showReportPopup}
                onHide={() => setShowReportPopup(false)}
                centered
                size="md"
                style={{
                    borderRadius: '16px',
                    overflow: 'hidden'
                }}
            >
                <Modal.Body className="p-4">
                    {/* Header Section */}
                    <div className="d-flex align-items-center mb-4">
                        {/* Alert Circle with ! */}
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#FFE5E5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '12px'
                        }}>
                            <span style={{ color: '#FF4D4F', fontWeight: 'bold' }}>!</span>
                        </div>

                        {/* Title and Reports Count */}
                        <div className="d-flex align-items-center">
                            <span style={{
                                color: '#FF4D4F',
                                marginRight: '12px',
                                fontSize: '16px',
                                fontWeight: '500'
                            }}>
                                Experience Reported
                            </span>
                            <span style={{
                                backgroundColor: '#FFE5E5',
                                borderRadius: '20px',
                                padding: '4px 12px',
                                color: '#FF4D4F',
                                fontSize: '14px'
                            }}>
                                {reportData.totalReports} Reports
                            </span>
                        </div>
                    </div>

                    {/* Content Section */}
                    <p style={{
                        fontSize: '14px',
                        marginBottom: '16px'
                    }}>
                        Multiple users reported content violations
                    </p>

                    {/* Reasons Box */}
                    <div style={{
                        backgroundColor: '#FFE5E5',
                        padding: '16px',
                        borderRadius: '8px',
                        marginBottom: '24px'
                    }}>
                        {reportData.reportReasons.map((reason, index) => (
                            <div key={index} className="d-flex align-items-center" style={{
                                marginBottom: index !== reportData.reportReasons.length - 1 ? '12px' : '0'
                            }}>
                                <span style={{
                                    color: '#FF4D4F',
                                    marginRight: '8px',
                                    fontSize: '20px'
                                }}>•</span>
                                <span style={{
                                    color: '#FF4D4F',
                                    fontSize: '14px'
                                }}>{reason}</span>
                            </div>
                        ))}
                    </div>

                    {/* Cancel Button */}
                    <div className="text-end">
                        <Button
                            variant="light"
                            onClick={() => setShowReportPopup(false)}
                            style={{
                                backgroundColor: '#DEE2E6',
                                border: 'none',
                                color: 'black',
                                padding: '6px 16px',
                                fontSize: '14px',
                                borderRadius: '6px'
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Rejection Modal */}
            <Modal
                show={showRejectionModal}
                onHide={() => setShowRejectionModal(false)}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
            >
                <Modal.Header closeButton className="bg-white border-bottom">
                    <Modal.Title>Rejection Experience</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Rejection Reason <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            placeholder="Enter rejection reason"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="warning"
                        onClick={() => {
                            setShowRejectionModal(false);
                            setTimeout(() => {
                                setShow(true);
                            }, 100);
                        }}
                        style={{
                            backgroundColor: '#EEB830',
                            border: 'none',
                            padding: '8px 24px',
                            color: 'white'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleRejection}
                        style={{
                            backgroundColor: '#F24822',
                            border: 'none',
                            padding: '8px 24px',
                            color: 'white'
                        }}
                    >
                        Reject
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditExperience;